<template>
  <div id="map-section" style="height: calc(100vh - 70px); width: 100%" v-if="!isLoading">
    <Map
      ref="mapView"
      :ships="assets"
      SelectedMap="default"
      @map-mode-change="handleMapModeChange"
    />
    <ShipSection
      v-show="!isLoading"
      :ships="assets"
      @toggle-trail="handleTrailToggle"
      @zoom-to-ship="zoomToShip"
      @toggle-visibility="handleVisibilityToggle"
      @show-all-ships="handleShowAll"
      @hide-all-ships="handleHideAll"
    />
  </div>
  <div class="text-center text-danger my-2" v-else>
    <b-spinner class="align-middle"></b-spinner>
    <strong>Loading...</strong>
  </div>
</template>

<script>
import Map from '@/views/map';
import ShipSection from '@/views/home/components/ShipSection';
import { mapState } from 'vuex';

export default {
  name: 'Home',
  components: {
    Map,
    ShipSection,
  },
  data() {
    return {
      isLoading: true,
    };
  },
  computed: {
    ...mapState('asset', {
      assets: (state) => state.assets.filter((asset) => asset.lastGpsData),
    }),
  },
  methods: {
    async fetchData() {
      await this.$store.dispatch('asset/fetchAndReconcileAssets');
    },
    handleMapModeChange(mode) {
      // Fetch new data based on mode when switching
      this.$store.dispatch('asset/getLastData', mode);
    },
    zoomToShip(ship) {
      // eslint-disable-next-line no-undef
      if (this.$refs.mapView && this.$refs.mapView.mapService && ship.lastLatLng) {
        this.$refs.mapView.mapService.panToShip(ship);
      }
    },
    async handleTrailToggle(payload) {
      const ship = this.assets.find((s) => s.massId === payload.massId);
      if (!ship) return;

      if (this.$refs.mapView && this.$refs.mapView.mapService) {
        await this.$refs.mapView.mapService.toggleTrail(payload.trail, ship);
      }
    },
    handleVisibilityToggle(payload) {
      this.$store.dispatch('asset/updateAssetVisibility', payload);
      if (this.$refs.mapView && this.$refs.mapView.mapService) {
        this.$refs.mapView.mapService.toggleShipVisibility(payload.massId, payload.isVisible);
      }
    },
    handleShowAll() {
      this.$store.dispatch('asset/setAllAssetsVisibility', true);
      if (this.$refs.mapView && this.$refs.mapView.mapService) {
        this.$refs.mapView.mapService.showAllShips();
      }
    },
    handleHideAll() {
      this.$store.dispatch('asset/setAllAssetsVisibility', false);
      if (this.$refs.mapView && this.$refs.mapView.mapService) {
        this.$refs.mapView.mapService.hideAllShips();
      }
    },
  },
  async mounted() {
    try {
      await this.fetchData();
    } finally {
      this.isLoading = false;
    }
  },
};
</script>
